/**
 * Extracts the policy name from a policy href URL. Expects a policy href of the format /<string>/<string>
 * if the name does not match this format the href will be used by default.
 *
 * @param href - The policy href URL to parse
 * @returns The policy name extracted from the href, or the original href if no match is found
 */
export function getPolicyNameFromHref(href: string) {
  return href.match(/\/v?([^/]+)$/)?.[1] || href;
}
